import React, { useState } from "react";
import { Modal, Collapse, Button, Pagination } from "antd";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { TreemapController, TreemapElement } from "chartjs-chart-treemap";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  TreemapController,
  TreemapElement,
  Tooltip,
  Legend,
  Title
);

const { Panel } = Collapse;

const ProfitCollapseModal = ({
  isModalVisible,
  selectedBienKiemSoat,
  chartData,
  chartDtData,
  modalData,
  showDetails,
  setShowDetails,
  modalColumns,
  onClose,
}) => {
  const renderCollapseContent = (item) => (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
        gap: "10px",
      }}
    >
      {modalColumns.map((col) => (
        <div key={col.key}>
          <strong>{col.title}:</strong> {item[col.key] ? item[col.key].toString() : "N/A"}
        </div>
      ))}
    </div>
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedData = modalData.slice(startIndex, endIndex);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    console.log("newest")
  };

  // Hàm chuyển đổi từ chartData dạng Pie sang Treemap
  const transformToTreemapData = (originalChartData) => {
    if (!originalChartData || !originalChartData.labels || !originalChartData.datasets) return [];

    const dataset = originalChartData.datasets[0];
    console.log(dataset)
    return dataset.data.map((value, index) => ({
      label: originalChartData.labels[index],
      value,
    }));
  };

  return (
    <Modal
      title={`Chi tiết các chuyến của xe: ${selectedBienKiemSoat}`}
      visible={isModalVisible}
      onCancel={onClose}
      footer={null}
      width="95%"
    >
      {(chartData || chartDtData) && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: "20px",
          }}
        >
          <div style={{ width: "100%" }}>
            <h3 style={{ textAlign: "center" }}>Phân bổ chi phí</h3>
            <Chart
              type="treemap"
              data={{
                datasets: [
                  {
                    label: "Chi phí",
                    tree: transformToTreemapData(chartData),
                    key: "value",
                    labels: {
                      display: true,
                    },
                    backgroundColor: (ctx) => {
                      const colors = ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"];
                      return colors[ctx.index % colors.length];
                    },
                  },
                ],
              }}
              options={{
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: (ctx) => {
                        const { raw } = ctx;
                        return `${raw.label}: ${raw.value}`;
                      },
                    },
                  },
                },
              }}
            />
          </div>

          <div style={{ width: "100%", marginTop: 20 }}>
            <h3 style={{ textAlign: "center" }}>Phân bổ doanh thu</h3>
            <Chart
              type="treemap"
              data={{
                datasets: [
                  {
                    label: "Doanh thu",
                    tree: transformToTreemapData(chartDtData),
                    key: "value",
                    labels: {
                      display: true,
                    },
                    backgroundColor: (ctx) => {
                      const colors = ["#36A2EB", "#FFCE56", "#FF6384", "#9966FF"];
                      return colors[ctx.index % colors.length];
                    },
                  },
                ],
              }}
              options={{
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: (ctx) => {
                        const { raw } = ctx;
                        return `${raw.label}: ${raw.value}`;
                      },
                    },
                  },
                },
              }}
            />
          </div>
        </div>
      )}

      {showDetails && (
        <div>
          <Collapse accordion ghost>
            {paginatedData.map((item) => (
              <Panel header={`Chuyến: ${item.ma_chuyen}`} key={item.ma_chuyen}>
                {renderCollapseContent(item)}
              </Panel>
            ))}
          </Collapse>
          <Pagination
            id="New"
            style={{ marginTop: "16px", textAlign: "center" }}
            current={currentPage}
            pageSize={pageSize}
            total={modalData.length}
            onChange={handlePageChange}
            showSizeChanger
            pageSizeOptions={["5", "10", "20", "50"]}
          />
        </div>
      )}
      <Button onClick={() => setShowDetails(!showDetails)}>
        {showDetails ? "Ẩn chi tiết" : "Xem chi tiết"}
      </Button>
    </Modal>
  );
};

export default ProfitCollapseModal;
